<template>
  <b-dropdown :key="filterKey" v-if="items"
    :id="filterId"
    class="filter-dropdown"
    size="sm"
    :toggle-class="filterClass"
  >
    <template #button-content>
      {{ $t("FILTER." + filterName + ".TITLE") }}
      <span v-if="values.length != 0">({{ values.length }})</span>
    </template>
    <b-dropdown-form>
    <b-form-checkbox
      switch
      size="sm"
      v-model="values"
      name=""
      value=""
      > Ingen status</b-form-checkbox
    >
    </b-dropdown-form>
    <b-dropdown-form
      v-for="ix in items"
      :key="ix"
    >
      <b-form-checkbox
        switch
        size="sm"
        v-model="values"
        name="check-button"
        :value="ix"
        >{{ ix }}</b-form-checkbox
      >
    </b-dropdown-form>
    <b-dropdown-divider v-if="amount != 0"></b-dropdown-divider>
    <b-dropdown-item v-if="amount.length != 0" @click="clearFilter">{{
      $t("FILTER.CLEAR_SELECTED")
    }}</b-dropdown-item>
  </b-dropdown>
</template>
<script>
export default {
props: {
  value: Array,
  amount: {
    default: 0,
    type: Number,
  },
  items: {
    default: () => [],
    type: Array
  },
  filterName: {
    default: "",
    type: String,
  },
},
data() {
  return {
    values: this.value
  };
},
methods: {
  clearFilter() {
    this.values = [];
  },
},
computed: {
  filterKey(){
      return "filterKey_" + this.filterName + "_" + this.value.length;
  },
  filterId() {
    return "filterId_" + this.filterName;
  },
  filterClass() {
    if (this.value.length != 0) {
      return ["filter-selected", "no-border"];
    } else {
      return ["no-border"];
    }
  },
},
watch: {
  value(){
    this.values = this.value;
  },
  values() {
    this.$emit("input", this.values);
  },
},
mounted() {
},
};
</script>
<style>
</style>